import { useImageBySearch } from '@lib/hooks/use-image-by-search';

export const ImageProduct = ({ business, className }: { business: any; className?: string }) => {
  const { imageSrc } = useImageBySearch(business.image_url, business.search_provider, 860);
  return (
    <div
      className={`${className}`}
      style={{
        backgroundImage: `url(${business.hasCYO ? business.image_url : imageSrc})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '8px',
      }}
    ></div>
  );
};
